// import React, { useEffect, useState, useCallback } from 'react';
// import Navigation from '../components/Navigation';
// import { NavLink } from 'react-router-dom';
// import base_url from '../config/Config';
// import axios from 'axios';
// import Sidebar from '../components/Sidebar';
// import Spinner from 'react-bootstrap/Spinner';
// import { FaEyeSlash } from 'react-icons/fa';
// import Cookies from 'js-cookie';

// const Loan = () => {
//     const [loanMaster, setLoanMaster] = useState([]);
//     const [isDownloading, setIsDownloading] = useState(false);
//     const [isDownloadingLmaster, setIsDownloadingLmaster] = useState(false);
//     const [isPendingCustomer, setIsPendingCustomer] = useState(false);
//     const [searchOption, setSearchOption] = useState('');
//     const [searchInput, setSearchInput] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [permissions, setPermissions] = useState([]);
//     const token = Cookies.get('authToken');

//         const loanMastersPerPage = 20;

//     // const getAllLoanMaster = useCallback(() => {
//     //     axios.get(`${base_url}/api/loan/loanList`, {
//     //         headers: {
//     //             "Content-Type": "application/json",
//     //             "Authorization": `Bearer ${token}`,
//     //         },
//     //     })
//     //         .then((response) => {
//     //             const sortedLoans = response.data.sort((a, b) => b.id - a.id); // sort by ID DESC
//     //             setLoanMaster(response.data.reverse());
//     //         })
//     //         .catch((error) => {
//     //             console.error("Error fetching loan master list:", error);
//     //         });
//     // }, [token]);
//   // Fetch permissions for logged-in admin

//     useEffect(() => {
//         const adminId = localStorage.getItem('adminId') || '';
//         axios.get(`${base_url}/api/auth/tabs/${adminId}`)
//             .then(res => setPermissions(res.data || []))
//             .catch(() => setPermissions([]));
//     }, []);

//     // Permission check helper
//     const hasPermission = useCallback((tabName, action) => {
//         const tab = permissions.find(t => t.tabName === tabName);
//         if (!tab) return false;
//         switch (action) {
//             case 'view': return !!tab.canView;
//             case 'edit': return !!tab.canEdit;
//             case 'download': return !!tab.canDelete; // using canDelete for download
//             default: return false;
//         }
//     }, [permissions]);


//     const getAllLoanMaster = useCallback(() => {
//         if (!hasPermission('Loan', 'view')) return;
//     axios.get(`${base_url}/api/loan/loanList`, {
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}`,
//         },
//     })
//         .then((response) => {
//             const sortedLoans = response.data.sort((a, b) => b.id - a.id); // Sort by ID DESC
//             setLoanMaster(sortedLoans); // Don't reverse again
//         })
//         .catch((error) => {
//             console.error("Error fetching loan master list:", error);
//         });
//      }, [token, hasPermission]);

//     useEffect(() => {
//         if (token) {
//             getAllLoanMaster();
//         }
//     }, [token, getAllLoanMaster]);

//    const handleExportLoan = async () => {
//         if (!hasPermission('Loan', 'download')) {
//             alert('You do not have permission to download loans.');
//             return;
//         }
//     setIsDownloading(true);
//    try {
//         const response = await axios.get(`${base_url}/api/export/pending`, {
//             responseType: 'blob',
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`,
//             },
//         });

//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'Loan_data.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         alert('Export Loan  successfully');
//     } catch (error) {
//         console.error('Error generating repayment:', error.response?.data || error.message);
//         alert('Export Loan Master not shown');
//     } finally {
//         setIsDownloading(false);
//     }
// };


//  const handleExportLoanMaster = async () => {
//      if (!hasPermission('Loan', 'download')) {
//             alert('You do not have permission to download loan master.');
//             return;
//         }
//     setIsDownloadingLmaster(true);
//     try {
//         const response = await axios.get(`${base_url}/api/export/loanMaster`, {
            
//             responseType: 'blob',
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`,
//             },
//         });

//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'Loan_Master_data.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         alert('Export Loan Master successfully');
//     } catch (error) {
//         console.error('Error generating repayment:', error.response?.data || error.message);
//         alert('Export Loan Master not shown');
//     } finally {
//         setIsDownloadingLmaster(false);
//     }
// };


// const handlePendingCustomer = async () => {
//      if (!hasPermission('Loan', 'download')) {
//             alert('You do not have permission to Pending Customer.');
//             return;
//         }
//     setIsPendingCustomer(true);
//     try {
//         const response = await axios.get(`${base_url}/api/customerFilter/pending`, {
            
//             responseType: 'blob',
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${token}`,
//             },
//         });

//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', 'Pending_customer.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         alert('Export Pending Customer successfully');
//     } catch (error) {
//         console.error('Error generating repayment:', error.response?.data || error.message);
//         alert('Export Pending Customer not shown');
//     } finally {
//         setIsPendingCustomer(false);
//     }
// };



//     // ✅ Search Filter Logic (same as your repayment page)
//     const handleSearch = (event) => {
//         event.preventDefault();
//         let filtered = [...loanMaster];

//         if (searchOption && searchInput) {
//             switch (searchOption) {
//                 case 'borrower_name':
//                     filtered = filtered.filter(item =>
//                         item.borrowerName?.toLowerCase().includes(searchInput.toLowerCase())
//                     );
//                     break;
//                 case 'loan_id':
//                     filtered = filtered.filter(item =>
//                         item.id?.toString() === searchInput
//                     );
//                     break;
//                 case 'customer_id':
//                     filtered = filtered.filter(item =>
//                         item.customerId?.toString() === searchInput
//                     );
//                     break;
//                 case 'phone':
//                     filtered = filtered.filter(item =>
//                         item.phoneNumber?.toString().includes(searchInput)
//                     );
//                     break;
//                 default:
//                     break;
//             }
//         }

//         setLoanMaster(filtered);
//         setCurrentPage(1);
//     };

//     const indexOfLastLoanMaster = currentPage * loanMastersPerPage;
//     const indexOfFirstLoanMaster = indexOfLastLoanMaster - loanMastersPerPage;
//     const loanMasters = loanMaster.slice(indexOfFirstLoanMaster, indexOfLastLoanMaster);
//     const totalPages = Math.ceil(loanMaster.length / loanMastersPerPage);
//     const maxPageButtons = 10;

//     const getPaginationRange = () => {
//         const mid = Math.floor(maxPageButtons / 2);
//         let start = Math.max(1, currentPage - mid);
//         let end = Math.min(totalPages, start + maxPageButtons - 1);
//         if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
//         return { start, end };
//     };

//     const { start: startPage, end: endPage } = getPaginationRange();

//      if (!hasPermission('Loan', 'view')) {
//         return (
//             <div className="text-center mt-5">
//                 <h3>Access Denied</h3>
//                 <p>You do not have permission to view this page.</p>
//             </div>
//         );
//     }
//     return (
//         <>
//             <div className='overviewsaa'>
//                 <h4>Loans Details</h4>
//             </div>
//             <div className='navigationss mb-5'>
//                 <Navigation />
//             </div>
//             <div className='container-fluid'>
//                 <div className='row'>
//                     <div className='col-lg-2 col-md-2 sidebarnavigartion'>
//                         <div className='lmssidebar'>
//                             <Sidebar />
//                         </div>
//                     </div>
//                     <div className='col-lg-10 col-md-10'>
//                         <div className='dashboardlms mt-5 text-center'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='searchtoll'>
//                                         <form onSubmit={handleSearch}>
//                                             <div className='row'>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required">
//                                                         <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
//                                                             <option value="">Search By</option>
//                                                             <option value="borrower_name">Borrower Name</option>
//                                                             <option value="loan_id">Loan Id</option>
//                                                             <option value="phone">Phone</option>
//                                                             <option value="customer_id">Customer Id</option>
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 col-3">
//                                                     <div className=" required">
//                                                         <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-1 col-3">
//                                                     <div className=" required iconsss">
//                                                         <button type="submit" className="btn btn-sm btn-primary">Search</button>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-2 mt-2">
//                                                     <div className='resion'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportLoan}
//                                                          disabled={isDownloading || !hasPermission('Loan', 'download')}>
//                                                             {isDownloading ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Pending Loan</>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                     </div>
//                                                    < div className="col-md-2 mt-2">
//                                                     <div className='resion'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handlePendingCustomer}
//                                                          disabled={isPendingCustomer || !hasPermission('Loan', 'download')}>
//                                                             {isPendingCustomer ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Pending Customer</>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                     </div>
//                                                     <div className="col-md-3 mt-2">
//                                                     <div className='resion'>
//                                                         <NavLink to="#" className="exportbutton" onClick={handleExportLoanMaster}
//                                                         disabled={isDownloadingLmaster || !hasPermission('Loan', 'download')}>
//                                                             {isDownloadingLmaster ? (
//                                                                 <Spinner animation="border" size="sm" />
//                                                             ) : (
//                                                                 <>Download Loan Master  </>
//                                                             )}
//                                                         </NavLink>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </form>
//                                     </div>
//                                 </div>
//                                 <div className='col-md-12 col-lg-12'>
//                                     <div className='allcustomer table-responsive table-striped mt-3'>
//                                         {loanMaster.length > 0 ? (
//                                             <table className="styled-table">
//                                                 <thead>
//                                                     <tr>
//                                                         <th>Loan_Id</th>
//                                                         <th>Customer_Id</th>
//                                                         <th>Product_Type</th>
//                                                         <th>Product_Name</th>
//                                                         <th>Borrower_Name</th>
//                                                         <th>Phone_Number</th>
//                                                         <th>Loan_Amount</th>
//                                                          <th>Create_Date</th>
//                                                          <th>Status</th>
//                                                         <th>Action</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {loanMasters.map((data, index) => (
//                                                         <tr key={index}>
//                                                             <td>{data.id}</td>
//                                                             <td>{data.customerId}</td>
//                                                             <td>PD_Loan</td>
//                                                             <td>{data.productName}</td>
//                                                             <td>{data.borrowerName}</td>
//                                                             <td>{data.mobileNumber}</td>
//                                                             <td>{data.loanAmount}</td>
//                                                             <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
//                                                            {/* <td>{data.status === 0 ? 'Pending' : data.status === 1 ? 'Active' : 'Unknown'}</td> */}
//                                                            <td> {data.status === 0 ? 'Pending' : data.status === 1 ? 'Active' : data.status === 3 ? 'Closed' : 'Unknown'} </td>
//                                                             <td className='iconss'>
//                                                                  {hasPermission('Loan', 'view') ? (
//                                                                 <NavLink to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.id}`}>
//                                                                     <FaEyeSlash />
//                                                                 </NavLink>
//                                                                  ) : (
//                                                                 <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
//                                                                 )}
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         ) : (
//                                             "No Loan Product"
//                                         )}
//                                     </div>
                                    
//                                     <div className="pagination-container">
//                                         <div className="pagination-box">
//                                             {startPage > 1 && (
//                                                 <>
//                                                     <button onClick={() => setCurrentPage(1)}>1</button>
//                                                     <span className="dots">...</span>
//                                                 </>
//                                             )}
//                                             {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
//                                                 <button
//                                                     key={startPage + i}
//                                                     className={currentPage === startPage + i ? 'active' : ''}
//                                                     onClick={() => setCurrentPage(startPage + i)}
//                                                 >
//                                                     {startPage + i}
//                                                 </button>
//                                             ))}
//                                             {endPage < totalPages && (
//                                                 <>
//                                                     <span className="dots">...</span>
//                                                     <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
//                                                 </>
//                                             )}
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Loan;



import React, { useEffect, useState, useCallback } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash, FaTimesCircle } from 'react-icons/fa';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

const Loan = () => {
    const [loanMaster, setLoanMaster] = useState([]);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingLmaster, setIsDownloadingLmaster] = useState(false);
    const [isPendingCustomer, setIsPendingCustomer] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [permissions, setPermissions] = useState([]);
    const [rejectingId, setRejectingId] = useState(null);
    const [pageLoading, setPageLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('active');
    const token = Cookies.get('authToken');

    const loanMastersPerPage = 20;

    useEffect(() => {
        const adminId = localStorage.getItem('adminId') || '';
        axios.get(`${base_url}/api/auth/tabs/${adminId}`)
            .then(res => setPermissions(res.data || []))
            .catch(() => setPermissions([]));
    }, []);

    const hasPermission = useCallback((tabName, action) => {
        const tab = permissions.find(t => t.tabName === tabName);
        if (!tab) return false;
        switch (action) {
            case 'view': return !!tab.canView;
            case 'edit': return !!tab.canEdit;
            case 'download': return !!tab.canDelete;
            default: return false;
        }
    }, [permissions]);

    const getAllLoanMaster = useCallback(() => {
        if (!hasPermission('Loan', 'view')) return;
        axios.get(`${base_url}/api/loan/loanList`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => {
                const sortedLoans = response.data.sort((a, b) => b.id - a.id);
                setLoanMaster(sortedLoans);
            })
            .catch((error) => {
                console.error("Error fetching loan master list:", error);
            })
            .finally(() => setPageLoading(false));
    }, [token, hasPermission]);

    useEffect(() => {
        if (token) {
            getAllLoanMaster();
        }
    }, [token, getAllLoanMaster]);

    // ✅ Reject Loan Handler
    // const handleRejectLoan = async (loanId) => {
    //     if (!hasPermission('Loan', 'edit')) {
    //         alert('You do not have permission to reject loans.');
    //         return;
    //     }

    //     const confirmReject = window.confirm(`Kya aap Loan ID ${loanId} ko Reject karna chahte hain?`);
    //     if (!confirmReject) return;

    //     setRejectingId(loanId);
    //     try {
    //         await axios.put(
    //             `${base_url}/api/loan/updateStatus/${loanId}`,
    //             { status: 2 }, // 2 = Rejected
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     "Authorization": `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         alert(`Loan ID ${loanId} successfully Reject ho gaya.`);
    //         getAllLoanMaster(); // Refresh list
    //     } catch (error) {
    //         console.error('Error rejecting loan:', error.response?.data || error.message);
    //         alert('Loan Reject karne mein error aaya. Please try again.');
    //     } finally {
    //         setRejectingId(null);
    //     }
    // };


    const handleRejectLoan = async (loanId) => {

    if (!hasPermission('Loan', 'edit')) {
        alert('You do not have permission to reject loans.');
        return;
    }

    const confirmReject = window.confirm(`Kya aap Loan ID ${loanId} ko Reject karna chahte hain?`);
    if (!confirmReject) return;

    setRejectingId(loanId);
    try {
        await axios.put(
            `${base_url}/api/loan/updateStatus?loanId=${loanId}`,
            { status: 2 },
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
        );
        alert(`Loan ID ${loanId} successfully Reject ho gaya.`);
        getAllLoanMaster();
    } catch (error) {
        console.error('Error rejecting loan:', error.response?.data || error.message);
        alert('Loan Reject karne mein error aaya. Please try again.');
    } finally {
        setRejectingId(null);
    }
};

    const handleExportLoan = async () => {
        if (!hasPermission('Loan', 'download')) {
            alert('You do not have permission to download loans.');
            return;
        }
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api/export/pending`, {
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Loan_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert('Export Loan successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Loan Master not shown');
        } finally {
            setIsDownloading(false);
        }
    };

    const handleExportLoanMaster = async () => {
        if (!hasPermission('Loan', 'download')) {
            alert('You do not have permission to download loan master.');
            return;
        }
        setIsDownloadingLmaster(true);
        try {
            const response = await axios.get(`${base_url}/api/export/loanMaster`, {
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Loan_Master_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert('Export Loan Master successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Loan Master not shown');
        } finally {
            setIsDownloadingLmaster(false);
        }
    };

    const handlePendingCustomer = async () => {
        if (!hasPermission('Loan', 'download')) {
            alert('You do not have permission to Pending Customer.');
            return;
        }
        setIsPendingCustomer(true);
        try {
            const response = await axios.get(`${base_url}/api/customerFilter/pending`, {
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Pending_customer.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            alert('Export Pending Customer successfully');
        } catch (error) {
            console.error('Error generating repayment:', error.response?.data || error.message);
            alert('Export Pending Customer not shown');
        } finally {
            setIsPendingCustomer(false);
        }
    };

    const handleSearch = (event) => {
        event.preventDefault();
        let filtered = [...loanMaster];

        if (searchOption && searchInput) {
            switch (searchOption) {
                case 'borrower_name':
                    filtered = filtered.filter(item =>
                        item.borrowerName?.toLowerCase().includes(searchInput.toLowerCase())
                    );
                    break;
                case 'loan_id':
                    filtered = filtered.filter(item =>
                        item.id?.toString() === searchInput
                    );
                    break;
                case 'customer_id':
                    filtered = filtered.filter(item =>
                        item.customerId?.toString() === searchInput
                    );
                    break;
                case 'phone':
                    filtered = filtered.filter(item =>
                        item.phoneNumber?.toString().includes(searchInput)
                    );
                    break;
                default:
                    break;
            }
        }

        setLoanMaster(filtered);
        setCurrentPage(1);
    };

    const filteredByTab = activeTab === 'rejected'
        ? loanMaster.filter(d => d.status === 2)
        : loanMaster.filter(d => d.status !== 2);

    const indexOfLastLoanMaster = currentPage * loanMastersPerPage;
    const indexOfFirstLoanMaster = indexOfLastLoanMaster - loanMastersPerPage;
    const loanMasters = filteredByTab.slice(indexOfFirstLoanMaster, indexOfLastLoanMaster);
    const totalPages = Math.ceil(filteredByTab.length / loanMastersPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

    if (!hasPermission('Loan', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return (
        <>
            <div className='overviewsaa'>
                <h4>Loans Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms  text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
                                                            <option value="">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="loan_id">Loan Id</option>
                                                            <option value="phone">Phone</option>
                                                            <option value="customer_id">Customer Id</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportLoan}
                                                            disabled={isDownloading || !hasPermission('Loan', 'download')}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Pending Loan</>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handlePendingCustomer}
                                                            disabled={isPendingCustomer || !hasPermission('Loan', 'download')}>
                                                            {isPendingCustomer ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Pending Customer</>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportLoanMaster}
                                                            disabled={isDownloadingLmaster || !hasPermission('Loan', 'download')}>
                                                            {isDownloadingLmaster ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Download Loan Master</>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    {/* Tab Toggle */}
                                    <div className='loan-tabs'>
                                        <button
                                            className={`loan-tab-btn${activeTab === 'active' ? ' loan-tab-active' : ''}`}
                                            onClick={() => { setActiveTab('active'); setCurrentPage(1); }}
                                        >
                                            Loan List ({loanMaster.filter(d => d.status !== 2).length})
                                        </button>
                                        <button
                                            className={`loan-tab-btn${activeTab === 'rejected' ? ' loan-tab-active loan-tab-rejected' : ''}`}
                                            onClick={() => { setActiveTab('rejected'); setCurrentPage(1); }}
                                        >
                                            Rejected Loans ({loanMaster.filter(d => d.status === 2).length})
                                        </button>
                                    </div>

                                    <div className='allcustomer table-responsive mt-3'>
                                        {pageLoading ? (
                                            <PageLoader text="Loading loans..." />
                                        ) : filteredByTab.length > 0 ? (
                                            <table className="styled-table">
                                                <thead>
                                                    <tr>
                                                        <th>Loan_Id</th>
                                                        <th>Customer_Id</th>
                                                        <th>Product_Type</th>
                                                        <th>Product_Name</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Phone_Number</th>
                                                        <th>Loan_Amount</th>
                                                        <th>Create_Date</th>
                                                        <th>Status</th>
                                                        <th>View</th>
                                                        <th>Reject</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loanMasters.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.customerId}</td>
                                                            <td>PD_Loan</td>
                                                            <td>{data.productName}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.loanAmount}</td>
                                                            <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
                                                            <td>
                                                                <span className={`badge ${
                                                                    data.status === 0 ? 'bg-warning text-dark' :
                                                                    data.status === 1 ? 'bg-success' :
                                                                    data.status === 2 ? 'bg-danger' :
                                                                    data.status === 3 ? 'bg-secondary' : 'bg-light text-dark'
                                                                }`}>
                                                                    {data.status === 0 ? 'Pending' :
                                                                     data.status === 1 ? 'Active' :
                                                                     data.status === 2 ? 'Rejected' :
                                                                     data.status === 3 ? 'Closed' : 'Unknown'}
                                                                </span>
                                                            </td>
                                                            <td className='iconss' style={{ textAlign: 'center' }}>
                                                                {hasPermission('Loan', 'view') ? (
                                                                    <NavLink to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.id}`}>
                                                                        <FaEyeSlash title="View Loan" />
                                                                    </NavLink>
                                                                ) : (
                                                                    <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                                )}
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {data.status === 0 && hasPermission('Loan', 'edit') ? (
                                                                    <button
                                                                        title="Reject Loan"
                                                                        onClick={() => handleRejectLoan(data.id)}
                                                                        disabled={rejectingId === data.id}
                                                                        style={{
                                                                            background: 'none',
                                                                            border: 'none',
                                                                            cursor: 'pointer',
                                                                            padding: 0,
                                                                            color: '#dc3545',
                                                                        }}
                                                                    >
                                                                        {rejectingId === data.id ? (
                                                                            <Spinner animation="border" size="sm" />
                                                                        ) : (
                                                                            <FaTimesCircle size={16} />
                                                                        )}
                                                                    </button>
                                                                ) : (
                                                                    <span style={{ color: '#ccc', fontSize: '12px' }}>—</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <p className="empty-state">
                                                {activeTab === 'rejected' ? 'Koi rejected loan nahi mila.' : 'No loan records found.'}
                                            </p>
                                        )}
                                    </div>

                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Loan;
